import { render, staticRenderFns } from "./MemberView.vue?vue&type=template&id=65fc7605&scoped=true"
import script from "./MemberView.vue?vue&type=script&lang=js"
export * from "./MemberView.vue?vue&type=script&lang=js"
import style0 from "./MemberView.vue?vue&type=style&index=0&id=65fc7605&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65fc7605",
  null
  
)

export default component.exports